<template>
  <div class="d-roll-box">
    <DigitRollCore
      v-if="!scrollBounce"
      ref="digitroll"
      :rollDigits="getContent"
      :dur="duration"
      :getHeight="getHeight"
      :getShowPrefix="getShowPrefix"
      :getPrefixContent="getPrefixContent"
      :getShowSuffix="getShowSuffix"
      :getSuffixContent="getSuffixContent"
      :getPrefixStyle="getPrefixStyle"
      :getLiStyle="getLiStyle"
      :getDivStyle="getDivStyle"
      :getOtherSymbolStyle="getOtherSymbolStyle"
      :getSuffixStyle="getSuffixStyle"
      :isFixed="isFixed"
      :digitRollTextAlign="digitRollTextAlign"
      :rotate="getRotate"
      :opacity="opacity"
      :options="options"
      :myid="myid"
    />
    <DigitSwitchCore
      v-else
      ref="digitSwitch"
      :endVal="getContent"
      :prefix="getPrefixContent"
      :getPrefixStyle="getPrefixStyle"
      :getShowPrefix="getShowPrefix"
      :suffix="getSuffixContent"
      :getSuffixStyle="getSuffixStyle"
      :getShowSuffix="getShowSuffix"
      :isFixed="isFixed"
      :decimals="getDecimals"
      :separator="getShowThousandSeparator"
      :getHeight="getHeight"
      :getLiStyle="getLiStyle"
      :getDivStyle="getDivStyle"
      :getOtherSymbolStyle="getOtherSymbolStyle"
      :duration="duration"
      :digitRollTextAlign="digitRollTextAlign"
      :rotate="getRotate"
      :opacity="opacity"
      :options="options"
      :myid="myid"
    />
  </div>
</template>

<script>
import DigitRollCore from "./digitRollCore"
import DigitSwitchCore from "./digitSwitchCore"

import eventMixin from "utils/event/eventMixin.js"
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [eventMixin, dataRenderMixin],
  name: "DigitRoll",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  components: { DigitSwitchCore, DigitRollCore },
  data() {
    return {
      digits: null,
      reloadTimer: null, // 用于数据轮询
      animateReloadTimer: null // 用于动画更新
    }
  },
  watch: {
    "options.animateInterval"(n, o) {
      clearInterval(this.animateReloadTimer)
      this.animateReloadFn()
    },
    "options.animateDuration"(n, o) {
      clearInterval(this.animateReloadTimer)
      this.animateReloadFn()
    },
    "options.dynamicData": {
      handler(n, o) {
        if (n && n.length > 0) {
          this.updateDynamicData(this.getContent)
        }
      },
      deep: true
    },
    "options.content": {
      handler(n, o) {
        if (n !== o) {
          this.updateDynamicData(n)
        }
      },
      deep: true
    },
    "options.getDataCount": {
      handler(n, o) {
        if (n !== o && this.noCacheComponent) {
          this.updateData()
        }
      },
    }
  },
  methods: {
    numFormat(num) {
      let decimal = ""
      num += ""
      let integer = num.split(".")[0]
      integer = (integer + "").replace(/\d{1,3}(?=(\d{3})+$)/g, "$&,")
      if (num.indexOf(".") != -1) {
        decimal = "." + num.split(".")[1]
      }
      return integer + decimal
    },
    changeDecimal(num, decimal) {
      if (isNaN(parseFloat(num))) {
        return 0
      }
      let multiple = 1
      for (let i = 0; i < decimal; i++) {
        multiple = multiple * 10
      }
      let temp = Math.round(num * multiple) / multiple
      let result = temp.toString()
      let pos_decimal = result.indexOf(".")
      if (pos_decimal < 0) {
        pos_decimal = result.length
        result += "."
      }
      while (result.length <= pos_decimal + decimal) {
        result += "0"
      }
      return result
    },
    animateReloadFn() {
      this.animateReloadTimer = setInterval(() => {
        if(this.scrollBounce){
          this.$refs.digitSwitch.start()
        }else{
          this.$refs.digitroll.resetStat(this.getContent.toString().length)
        }
      }, this.options.animateInterval * 1000)
    },
    async updateData() {
      this.updateNormalRect.call(
        this,
        datas => {
          /*大屏外接数据空数据展示位暂无数据*/
          if(this.request_prefix == "bigScreen" && datas.length === 0){
            if(this.options.emptyDataShowLocal){
              this.$changeOptionsEV(this.options.emptyContent, "content", false, null, this.myid, true)
            }else{
              this.$changeOptionsEV("暂无数据", "content", false, null, this.myid, true)
            }
          }
          if(datas && datas[0]){
            let content = datas[0][Object.keys(datas[0])[0]].value
            if(this.request_prefix === "bigScreen" && !content && content !== 0){
              if(this.options.emptyDataShowLocal){
                content = this.options.emptyContent
              }
            }
            this.$changeOptionsEV(content, "content", false, null, this.myid, true)
          }
        },
        1
      )
    },
    // 警告数据
    updateDynamicData(contentValue) {
      if(!this.onWarningStatus){
        return
      }
      this.getResultObj()
      // 遍历动态数据条件
      for (let i = 0; i < this.options.dynamicData.length; i++) {
        const dynamicDataItem = this.options.dynamicData[i]
        switch (dynamicDataItem.condition) {
          case "等于":
            if (contentValue === Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              continue
            }
            break
          case "不等于":
            if (contentValue !== Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              continue
            }
            break
          case "大于等于":
            if (contentValue >= Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              continue
            }
            break
          case "小于等于":
            if (contentValue <= Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              continue
            }
            break
          case "大于":
            if (contentValue > Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              continue
            }
            break
          case "小于":
            if (contentValue < Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              continue
            }
            break
          case "介于":
            if (
              contentValue > Number(dynamicDataItem.conditionRange[0]) &&
              contentValue <= Number(dynamicDataItem.conditionRange[1])
            ) {
              this.getResultObj(dynamicDataItem)
              continue
            }
            break
        }
      }
    },
    getResultObj(dynamicDataItem){
      if(dynamicDataItem){
        this.warningFontColor = this.$parseColor(dynamicDataItem.resultFontColor)
        this.warningBgColor = this.$parseColor(dynamicDataItem.resultBgColor)
        this.warningBgStartColor = this.$parseColor(dynamicDataItem.resultBgStartColor)
        this.warningBgEndColor = this.$parseColor(dynamicDataItem.resultBgEndColor)
        this.warningBgColorlinearGradientAngle = dynamicDataItem.resultBgColorlinearGradientAngle
        this.warningBgImage = dynamicDataItem.resultBgImage
      }else{
        this.warningFontColor = this.$parseColor(this.options.fontColor)
        this.warningBgColor = this.$parseColor(this.options.bgColor)
        this.warningBgStartColor = this.$parseColor(this.options.bgStartColor)
        this.warningBgEndColor = this.$parseColor(this.options.bgEndColor)
        this.warningBgColorlinearGradientAngle = this.options.bgColorlinearGradientAngle
        this.warningBgImage = this.options.bgImage
      }
    }
  },
  mounted() {
    this.animateReloadFn()
    if (this.noCacheComponent) {
      this.updateData()
      if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
        this.reloadTimer = setInterval(() => this.updateData(), this.updateTimer)
      }
    }
    this.updateDynamicData(this.getContent)
  },
  destroyed() {
    if (this.reloadTimer) {
      clearInterval(this.reloadTimer)
      this.reloadTimer = null
    }
    clearInterval(this.animateReloadTimer)
    this.animateReloadTimer = null
  },
  computed: {
    duration() {
      return this.options.animateDuration * 1000
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false, false, false, true)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    },
    getShowThousandSeparator() {
      return this.options.showThousandSeparator ? "," : ""
    },
    isFixed() {
      return this.options.isFixed
    },
    getDecimals() {
      return this.options.decimal
    },
    getAnimateInterval() {
      return this.options.animateInterval * 1000
    },
    getContent() {
      if(this.scrollBounce){
        //跳动
        let contentVal = this.options.content
        // 展示千位符时需要重新修改格式
        if(this.options.showThousandSeparator && typeof contentVal === "string"){
          contentVal = parseFloat(contentVal.replaceAll(",", ""))
        }else{
          contentVal = parseFloat(this.options.content)
        }
        return contentVal
      }else{
        let result = this.options.content + ""
        if (this.getDecimals) {
          let index1 = result.indexOf(".")
          if(index1 === -1 || (index1 + this.getDecimals + 1) !== result.length){
            // 解决本身存在小数点后切换动画效果的报错的问题
            result = this.changeDecimal(result, this.getDecimals)
          }
        } else if(result.indexOf(".") !== -1){
          let arr1 = result.split(".")
          let num1 = ''
          for (let i = 0; i < arr1.length - 1; i++) {
            num1 = num1 + arr1[i]
          }
          this.options.content = num1
        }
        if (this.getShowThousandSeparator) {
          this.options.content = this.numFormat(this.options.content)
        } else if(result.indexOf(",") !== -1){
          let arr1 = result.split(",")
          let num1 = ''
          for (let i = 0; i < arr1.length; i++) {
            num1 = num1 + arr1[i]
          }
          result = num1
        }
        return result
      }
    },
    getHeight() {
      return this.options.height
    },
    getPrefixContent() {
      return this.options.prefixContent
    },
    getShowPrefix() {
      return this.options.showPrefix
    },
    getShowSuffix() {
      return this.options.showSuffix
    },
    getSuffixContent() {
      return this.options.suffixContent
    },
    getBgColor() {
      let bgColorStyle = {}, background = ""
      switch (this.options.bgColorType) {
        case "纯色":
          background = this.options.bgColor
          if (this.onWarningStatus) {
            background = this.warningBgColor || this.options.bgColor
          }
          bgColorStyle = {
            background: this.$parseColor(background),
            "border-radius": "4px"
          }
          break
        case "渐变":
          background =
            `linear-gradient(${this.options.bgColorlinearGradientAngle}deg,${this.$parseColor(this.options.bgStartColor)},${this.$parseColor(this.options.bgEndColor)})`
          if (this.onWarningStatus) {
            background = `linear-gradient(${this.warningBgColorlinearGradientAngle}deg,${this.$parseColor(this.warningBgStartColor)},${this.$parseColor(this.warningBgEndColor)})`
          }
          bgColorStyle = {
            background: background,
            "border-radius": "4px"
          }
          break
        case "边框":
          background = this.options.borderColor
          if (this.onWarningStatus) {
            background = this.warningBgColor || this.options.borderColor
          }
          bgColorStyle = {
            border: `2px solid ${this.$parseColor(background)}`,
            "border-radius": "4px"
          }
          break
        case "图片":
          background = `url(${this.options.bgImage}) no-repeat center center`
          if (this.onWarningStatus) {
            background = `url(${this.warningBgImage}) no-repeat center center`
          }
          bgColorStyle = {
            background: background
          }
          break
        case "无":
          bgColorStyle = {}
          break
      }
      return bgColorStyle
    },
    getLiStyle() {
      let result = {
        height: this.options.height + "px",
        "margin-right": this.options.marginRight + "px",
        ...this.getBgColor
      }
      if (!this.options.isFixed) {
        result.display = "flex"
      } else {
        result.width = this.options.numberWidth + "px"
      }
      return result
    },
    getFontColor() {
      let fontColor = this.options.fontColor
      if (this.onWarningStatus) {
        fontColor = this.warningFontColor
      }
      return {
        color: this.$parseColor(fontColor),
      }
    },
    getDivStyle() {
      return {
          ...this.getFontColor,
        "font-Family": this.options.fontFamily,
        "font-size": this.options.fontSize + "px",
        "font-weight": this.options.fontWeight
      }
    },
    getOtherSymbolStyle() {
      // 千分位逗号和小数点的样式
      let result = {
        ...this.getFontColor,
        "font-Family": this.options.fontFamily,
        "font-size": this.options.fontSize + "px",
        "font-weight": this.options.fontWeight,
        height: this.options.height + "px",
        "line-height": this.options.height + "px",
        "margin-right": this.options.marginRight + "px"
      }
      if (this.options.isFixed) {
        result.width = "10px"
        result.float = "left"
      }
      if (this.options.showSeparatorBackground) {
        Object.assign(result, { ...this.getBgColor })
      }
      return result
    },
    getPrefixStyle() {
      let result = {
        color: this.$parseColor(this.options.prefixFontColor),
        "font-Family": this.options.prefixFontFamily,
        "font-size": this.options.prefixFontSize + "px",
        "font-weight": this.options.prefixFontWeight,
        "margin-bottom": this.options.prefixFontMarginBottom + "px",
        "margin-right": this.options.prefixFontMarginRight + "px"
      }
      if (this.options.isFixed) {
        result.float = "left"
        result["margin-top"] = this.options.prefixFontMarginBottom + "px"
      }
      return result
    },
    getSuffixStyle() {
      let result = {
        color: this.$parseColor(this.options.suffixFontColor),
        "font-Family": this.options.suffixFontFamily,
        "font-size": this.options.suffixFontSize + "px",
        "font-weight": this.options.suffixFontWeight,
        "margin-bottom": this.options.suffixFontMarginBottom + "px",
        "margin-left": this.options.suffixFontMarginLeft + "px"
      }
      if (this.options.isFixed) {
        result.float = "left"
        result["margin-top"] = this.options.suffixFontMarginBottom + "px"
      }
      return result
    },
    digitRollTextAlign() {
      return this.options.digitRollTextAlign
    },
    getRotate() {
      return this.options.rotate
    },
    opacity(){
      return this.options.opacity / 100
    },
    scrollBounce(){
      let isBounce = this.options.scrollBounce
      if(isBounce === undefined){
        isBounce = true
      }
      return isBounce
    },
    // 是否开启了预警状态 且 有条件数据
    onWarningStatus(){
      if (this.options.onWarning && this.options.dynamicData && this.options.dynamicData.length > 0) {
        return true
      }else{
        return false
      }
    },
    warningFontColor: {
      get() {
        return this.options.warningFontColor || this.options.fontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningFontColor", false)
      }
    },
    warningBgColor: {
      get() {
        return this.options.warningBgColor || this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningBgColor", false)
      }
    },
    warningBgStartColor: {
      get() {
        return this.options.warningBgStartColor || this.options.bgStartColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningBgStartColor", false)
      }
    },
    warningBgEndColor: {
      get() {
        return this.options.warningBgEndColor || this.options.bgEndColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningBgEndColor", false)
      }
    },
    warningBgColorlinearGradientAngle: {
      get() {
        return this.options.warningBgColorlinearGradientAngle || this.options.bgColorlinearGradientAngle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningBgColorlinearGradientAngle", false)
      }
    },
    warningBgImage: {
      get() {
        return this.options.warningBgImage || this.options.bgImage
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningBgImage", false)
      }
    },
  }
}
</script>
